<h2 class="complete-profile-title">Personal Information</h2>
<form (submit)="submit($event)" novalidate appAutoValidate>
  <div class="grid grid cols-1 gap-4">
    <div class="form-group">
      <label for="">I am creating profile for</label>
      <app-select-field [options]="attributeService.attributes().profile_for" [formField]="form.profile_for"></app-select-field>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-group">
        <label for="">First Name</label>
        <input pInputText class="border" type="text" [formField]="form.first_name">
      </div>
      <div class="form-group">
        <label for="">Last Name</label>
        <input pInputText class="border" type="text" [formField]="form.last_name">
      </div>
      <div class="form-group">
        <label for="">Birth Year</label>
        <input pInputText type="number" [formField]="form.birth_year">
      </div>
      <div class="form-group">
        <label for="">Sex</label>
        <p-selectButton [options]="[{label:'Male',value:'male'},{label:'Female',value:'female'}]" [formField]="form.sex"></p-selectButton>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <div class="form-group">
        <label for="">Height <span class="text-primary font-bold">{{ form.height().value()  | cmToFeet }}</span></label>
        <div class="mt-5"></div>
        <p-slider [min]="135" [max]="215" [formField]="form.height"></p-slider>
      </div>
      <div class="form-group">
        <label for="">Weight</label>
        <app-select-field class="w-full" [options]="weightOptions()" [formField]="form.weight"></app-select-field>
      </div>
    </div>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="form-group">
        <label for="">Body Build</label>
        <app-select-field class="w-full" [options]="attributeService.attributes().body_build" [formField]="form.body_build"></app-select-field>
      </div>
      <div class="form-group">
        <label for="">Complexion</label>
        <app-select-field class="w-full" [options]="attributeService.attributes().complexion" [formField]="form.complexion"></app-select-field>
      </div>
    </div>
  </div>
  <button [disabled]="form().invalid()" class="mt-6 btn-base bg-primary text-white w-full">
    @if (loading()) {
      <i class="fa fa-spinner animate-spin"></i>
    }
    @if (standalone()) {
      Save
    } @else {
      Next <i class="fa fa-chevron-right text-xs"></i>
    }
  </button>

</form>
